import React, { FunctionComponent } from 'react'
// @ts-ignore
import { Field, reduxForm } from 'redux-form'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'

import renderField from 'Containers/Validation/renderField'
import validate from 'Containers/Validation/validate'
import Alert from 'Shared/components/Alert'
import { AlertWrapper, FormWrapper } from './styles'

type ChangeEmailProps = {
  handleSubmit: () => void
  pristine: boolean
  submitting: boolean
  emailChanged: boolean
  emailUsed: boolean
}

const ChangeEmail: FunctionComponent<ChangeEmailProps> = ({
  handleSubmit,
  pristine,
  submitting,
  emailChanged,
  emailUsed,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {emailChanged && (
        <AlertWrapper>
          <Alert color="success" icon noGap>
            <div className="alert__text">{t('settingsPage.emailChanged')}</div>
          </Alert>
        </AlertWrapper>
      )}
      {emailUsed && (
        <AlertWrapper>
          <Alert color="danger" icon noGap>
            <div className="alert__title">{t('errorsPage.error')}</div>
            <div className="alert__text">{t('campaignsPage.emailIsUsed')}</div>
          </Alert>
        </AlertWrapper>
      )}
      <FormWrapper>
        <form className="form change_password_form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('settingsPage.chooseEmail')}
            </span>
            <div className="form__form-group-field">
              <Field
                component={renderField}
                name="email"
                placeholder="example@mail.com"
                type="email"
              />
            </div>
          </div>
          <button
            className="btn btn-success btn-settings account__btn--small"
            disabled={pristine || submitting}
            type="submit"
          >
            {t('settingsPage.updateEmail')}
          </button>
        </form>
      </FormWrapper>
    </>
  )
}

export default compose(
  //  eslint-disable-next-line @typescript-eslint/no-explicit-any
  compose<any>(
    reduxForm({
      form: 'change_email',
      validate,
    })
  )
)(ChangeEmail)
